// =====================================
//
//   OrderList Controller
//   Author: Wayne
//   createtime: 2016 / 08 / 30
//
// =====================================

window.InifECMobileApp.controller("OrderListAllController", ['$scope', '$state', '$timeout', '$rootScope', 
    'UserService', 'OrderService', '$stateParams',
	function($scope, $state, $timeout, $rootScope, 
        UserService, OrderService, $stateParams) {

        var getOrderList = function() {
            if(!$scope.isLogin || $scope.isLoading || $scope.isNoMore || $scope.isEmpty){
                return;
            }

            $scope.isLoading = true;
            OrderService.getOrderList($scope.start, $scope.len).then(function(result){

                if(result && result.length) {
                    Array.prototype.push.apply($scope.orders, result);
                } else if ($scope.orders.length > 0) {
                    $scope.isNoMore = true;
                } else if ($scope.orders.length == 0) {
                    $scope.isEmpty = true;
                }

                $scope.start = $scope.start + $scope.len;
                $scope.isLoading = false;
            }, function(error) {
                $scope.isLoading = false;
                $scope.isError = true;
            });
        };

        var getDeliveryTitle = function(order){

            if(order.delivery == 0){
                return '自行取貨';
            } else if(order.delivery == 1){
                return '宅配';
            } else if(order.delivery == 2){
                return '計程車送件';
            } 
        };

        var getOrderListState = function(){

            $scope.isOrderAll = false;
            $scope.isOrderPay = false;
            $scope.isOrderDiscard = false;
            $scope.isOrderSuccess = false;

            switch($scope.state){
                case window.STATES.ORDER_LIST_ALL:
                    $scope.isOrderAll = true;
                    break;
                case window.STATES.ORDER_LIST_PAY:
                    $scope.isOrderPay = true;
                    break;
                case window.STATES.ORDER_LIST_DISCARD:
                    $scope.isOrderDiscard = true;
                    break;
                case window.STATES.ORDER_LIST_SUCCESS:
                    $scope.isOrderSuccess = true;
                    break;
            }
        };

        var getOrderCoverImage = function(order) {
            
            if(!order || !order.orderitems || order.orderitems.length == 0 || !order.orderitems[0].coverurl){
                return "about:blank";
            }

            return order.orderitems[0].coverurl.replace('medium', 'small');
        };

        // --------------------------------
        // 開啟登入modal
        // --------------------------------
        var login = function() {

            $rootScope.$broadcast("OPEN_LOGIN_MODAL");
        }

        var init = function() {
            if(!$rootScope.useNativeLoginModal){
                $rootScope.useNativeLoginModal = $stateParams.useNativeLoginModal;    
            }

            $scope.isLoading = true;
            UserService.getUserInfo().then(function(result){
                $scope.isLoading = false;
                $scope.isLogin = true;
                $scope.isNoLogin = false;
                $scope.isNoMore = false;
                $scope.isEmpty = false;
                $scope.start = 0;
                $scope.orders.length = 0;

                getOrderList();
                getOrderListState();
            }, function(error){
                $scope.isLoading = false;
                $scope.isNoLogin = true;
            });
        }

	    //==========================
        //  Events
        //==========================
        $scope.$on("$stateChangeSuccess", function(event, toState, toParams, fromState, fromParams) {
            $scope.state = $state.current.name;
        });

        $scope.$on("ORDER_STATUS_UPDATE", function(event, data) {
            
            if(data && $scope.orders.length > 0) {
                for(var i = 0; i < $scope.orders.length; i++) {
                    if($scope.orders[i].orderid == data.orderid) {
                        $scope.orders[i].orderstatus = data.orderstatus;
                    }
                }
            }
        });
        
        $scope.$on('LOGIN_SUCCESS', function(event, data){
            init();
        });

        $scope.$on('LOGOUT_SUCCESS', function(event, data){
            $scope.orders.length = 0;
            $scope.isNoLogin = true;
            $scope.isLogin = false;
        });

        //==========================
        //  Members
        //==========================
        $scope.state;
        $scope.start = 0;
        $scope.len = 20;
        $scope.isLoading = false;
        $scope.isNoMore = false;
        $scope.isEmpty = false;
        $scope.isError = false;
        $scope.isLogin = false;
        $scope.isNoLogin = false;
        $scope.orders = [];
        $scope.isOrderAll = false;
        $scope.isOrderPay = false;
        $scope.isOrderDiscard = false;
        $scope.isOrderSuccess = false;

        //==========================
        //  Methods
        //==========================
        $scope.getDeliveryTitle = getDeliveryTitle;
        $scope.getOrderList = getOrderList;
        $scope.getOrderCoverImage = getOrderCoverImage;
        $scope.login = login; // 開啟登入modal

        //==========================
        //  Init
        //==========================
        init();
	}
]);